import React, { useEffect, useMemo, useRef, useState } from "react";
import { Marker, Polyline, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L, { Path } from 'leaflet';
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
// import TextPolyline from "../modules/TextPolyline";
import '../../styles/Pillars04.css'


// Создаем иконку для границ задач
const createBorderIcon = () => {
    return L.divIcon({
        html: ``,
        iconSize: [14, 14],
        iconAnchor: [7, 7],
        className: 'task-border-icon'
    });
};

// Форматирование даты с временем в формате HH:MM dd.mm.yyyy
const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        // Получаем локальную дату и время в формате ISO
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes} ${day}.${month}.${year}`;
    } catch {
        return '';
    }
};

const colorsForStatuses = new Map([['progress', '#3874cb'], ['done', '#60AB52'], ['paused', '#e65100'], ['cancelled', '#424242']])

export const LayerPlan = props => {
    const map = useMap();
    const dispatch = useDispatch();
    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });
    const [keyForRender, setKeyForRender] = useState(0)
    // const [showFiders, setShowFiders] = useState(JSON.parse(localStorage.getItem('kanban_settings') || '{}')?.showFiders || false);
    const usersSettings = useSelector(state => state.state.usersSettings)
    const drawing = useSelector(state => state.state.drawing)

    



    // Динамическое создание CSS стилей для каждого пользователя
    useEffect(() => {
        if (!usersSettings) return;
        // Создаем или обновляем style элемент
        let styleElement = document.getElementById('dynamic-phantom-tooltips');
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = 'dynamic-phantom-tooltips';
            document.head.appendChild(styleElement);
        }

        // Генерируем CSS для каждого пользователя
        const cssRules = usersSettings.map(user => {
            const settings = user.settings || {};
            return `
                .tooltip-user-${user.id} {
                    background-color: ${settings.line_color || 'rgba(197, 197, 197, 0.7)'} !important;
                    color: ${settings.text_color || '#333'} !important;
                    border: 1px solid ${settings.line_color || '#333'} !important;
                    border-radius: 4px !important;
                    font-size: 12px !important;
                    font-weight: bold !important;
                    font-style: italic !important;
                    padding: 1px 2px !important;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
                    
                    // min-width: 120px !important;
                    // text-align: center !important;
                    // position: relative !important;
                }
                
                /* Создаем соединительную линию от tooltip к объекту */
                .tooltip-user-${user.id}::after {
                    content: '' !important;
                    position: absolute !important;
                    left: -30px !important;
                    top: 100% !important;
                    width: 30px !important;
                    height: 2px !important;
                    background-color: ${settings.line_color || '#000000'} !important;
                    transform-origin: top right !important;
                    transform: translateY(-50%) rotate(-45deg) !important;
                    z-index: 1000 !important;
                }

                
                /* Стрелка на конце линии - указывает на объект */
                .tooltip-user-${user.id}::before {
                    content: '' !important;
                    position: absolute !important;
                    left: -17px !important;  
                    top: 48px !important;
                    width: 0 !important;
                    height: 0 !important;
                    border-top: 5px solid transparent !important;
                    border-bottom: 5px solid transparent !important;
                    border-right: 8px solid ${settings.line_color || '#000000'} !important;
                    transform-origin: center !important;
                    transform: translateY(-50%) rotate(-45deg) !important;
                    z-index: 1001 !important;
                }
            `;
        }).join('\n');

        // Добавляем базовые стили
        const baseCss = `
            .dynamic-phantom-tooltip {
                transition: all 0.3s ease !important;
                cursor: pointer !important;
                z-index: 1000 !important;
            }
            .dynamic-phantom-tooltip:hover {
                transform: scale(1.05) !important;
                z-index: 1010 !important;
            }
            
            /* Анимация появления */
            .dynamic-phantom-tooltip {
                animation: tooltipFadeIn 0.4s ease-out !important;
            }
            
            @keyframes tooltipFadeIn {
                0% {
                    opacity: 0;
                    transform: translateY(-10px) scale(0.9);
                }
                100% {
                    opacity: 1;
                    transform: translateY(0) scale(1);
                }
            }`;

        const borderIconCss = ` 
            /* Стили для иконок границ задач */
            .task-border-icon {
                background: rgba(255, 255, 255, 0.9) !important;
                border: 2px solid #3874cb !important;
                border-radius: 50% !important;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
                transition: all 0.3s ease !important;
            }
            
        `;

        styleElement.innerHTML = cssRules + borderIconCss;

        // Очистка при размонтировании
        return () => {
            const element = document.getElementById('dynamic-phantom-tooltips');
            if (element) {
                element.remove();
            }
        };
    }, [usersSettings]);
    // console.log(JSON.parse(localStorage.getItem('kanban_settings') || '{}')?.showFiders)
    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };

        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);
        // map.on('phantom:show', () => setShowFiders(true));
        // map.on('phantom:hide', () => setShowFiders(false));
        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
            // map.off('phantom:show', () => setShowFiders(true));
            // map.off('phantom:hide', () => setShowFiders(false));
        };


    }, [map]);


    // Разделяем селекторы для избежания создания нового объекта при каждом вызове
    const { fiders: fidersFiltered } = useSelector((state) => state.state.electricityFiltered);
    const printing = useSelector((state) => state.helper.printing);
    const tasks = useSelector((state) => state.tasks.tasks);

    // Мемоизируем фильтрацию с правильными зависимостями
    const fiders = useMemo(() => {
        if (!fidersFiltered) return [];
        return fidersFiltered
        // return fidersFiltered.filter(f => f.stage === '4');
    }, [fidersFiltered]);


    // Используем актуальные значения из состояния карты
    const zoom = mapState.zoom;
    const bounds = printing
        ? new L.LatLngBounds(
            [printing.bounds.south, printing.bounds.west],
            [printing.bounds.north, printing.bounds.east]
        )
        : mapState.bounds;


    // Мемоизируем mounted fiders для оптимизации поиска
    const [taskFidersMap, tasksBorders] = useMemo(() => {
        //Отфильтровываем только задасчи с фидерами
        if (!tasks) return [new Map(), []];
        const tasksFiltered = tasks.filter(t => t.type === 'contour' && t.data?.objects?.fiders)
        if (!tasksFiltered) return [new Map(), []];
        const fidersMap = new Map();
        const tasksBordersPillarsIds = new Set(tasksFiltered.map(t => t.data.hidePillars || []).flat().filter(t => tasksFiltered.find(tf => tf.data?.objects?.pillars?.includes(t))))
        const tasksBordersCoords = new Set()
        //По каждой задаче формируем 
        for (const task of tasksFiltered) {
            for (const fid of task.data.objects.fiders) {
                const fider = fiders.find(f => f.id === fid)
                const segments = []
                if (fider) {
                    const taskPillars = [...task.data?.objects?.pillars || [], ...task.data?.hidePillars || []]
                    const taskTransformers = task.data?.transformers || []
                    fider.connected.forEach((obj, i) => {
                        if (obj?.type === 'pillar') {
                            const pillar = taskPillars.find(p => p === obj.id)
                            if (pillar) {
                                segments.push(i)
                            }
                            if (tasksBordersPillarsIds.has(obj.id)) {
                                tasksBordersCoords.add(fider.coordinates[i])
                                tasksBordersPillarsIds.delete(obj.id)
                            }
                        }
                        if (obj?.type === 'transformer') {
                            const transformer = taskTransformers.find(p => p === obj.id)
                            if (transformer) {
                                segments.push(i)
                            }
                        }
                    })

                }

                fidersMap.set(
                    fid,
                    [...(fidersMap.get(fid) || []), {
                        text: `${task.title.match(/План \d+/g)} ${formatDate(task.deadline)} ${usersSettings.find(us => us.id === task.responsible)?.name || `id${task.id}`}`,
                        status: task.status,
                        segments: segments,
                        responsible: task.responsible,
                        id: task.id
                    }]
                );
            }
        }
        return [fidersMap, [...tasksBordersCoords]];
    }, [tasks, fiders]);

    useEffect(() => {
        setKeyForRender(prev => prev + 1)
    }, [taskFidersMap])

    // Функция для проверки пересечения двух прямоугольников тултипов
    const checkTooltipIntersection = (tooltip1, tooltip2, map) => {
        try {
            const zoom = map.getZoom();
            const pixelsPerDegree = Math.pow(2, zoom) * 256 / 360;

            // Размеры тултипа (примерные)
            const tooltipWidth = 250; // px
            const tooltipHeight = 25; // px

            // Конвертируем географические координаты в пиксели
            const pos1 = map.latLngToContainerPoint([tooltip1.lat, tooltip1.lng]);
            const pos2 = map.latLngToContainerPoint([tooltip2.lat, tooltip2.lng]);

            // Добавляем смещение тултипа
            const offset1 = tooltip1.offset || [18, -35];
            const offset2 = tooltip2.offset || [18, -35];

            pos1.x += offset1[0];
            pos1.y += offset1[1];
            pos2.x += offset2[0];
            pos2.y += offset2[1];

            // Проверяем пересечение прямоугольников
            const rect1 = {
                left: pos1.x,
                right: pos1.x + tooltipWidth,
                top: pos1.y,
                bottom: pos1.y + tooltipHeight
            };

            const rect2 = {
                left: pos2.x,
                right: pos2.x + tooltipWidth,
                top: pos2.y,
                bottom: pos2.y + tooltipHeight
            };

            return !(rect1.right < rect2.left ||
                rect2.right < rect1.left ||
                rect1.bottom < rect2.top ||
                rect2.bottom < rect1.top);
        } catch (error) {
            console.warn('Error checking tooltip intersection:', error);
            return false;
        }
    };

    // Группируем субфидеры по задачам и фильтруем пересекающиеся тултипы только внутри каждой задачи
    const visibleSubfiders = useMemo(() => {
        const taskGroups = new Map();
        const visibleSubfiderIds = new Set();

        // Группируем субфидеры по задачам
        fiders.forEach((fider) => {
            const tasks = taskFidersMap.get(fider.id);
            if (!tasks) return;

            tasks.forEach((task) => {
                // Вычисляем центральную точку субфидера для тултипа
                let centerLat = 0, centerLng = 0;
                const segments = task.segments;

                if (segments.length > 0) {
                    const coords = fider.coordinates.slice(Math.min(...segments), Math.max(...segments) + 1);
                    coords.forEach(coord => {
                        centerLat += coord[0];
                        centerLng += coord[1];
                    });
                    centerLat /= coords.length;
                    centerLng /= coords.length;
                } else if (fider.coordinates.length > 0) {
                    const midIdx = Math.floor(fider.coordinates.length / 2);
                    centerLat = fider.coordinates[midIdx][0];
                    centerLng = fider.coordinates[midIdx][1];
                }

                const subfiderId = `${fider.id}_${task.id}`;
                const segmentLength = segments.length > 0
                    ? Math.max(...segments) - Math.min(...segments) + 1
                    : fider.coordinates?.length || 0;

                // Группируем по задачам
                if (!taskGroups.has(task.id)) {
                    taskGroups.set(task.id, []);
                }

                taskGroups.get(task.id).push({
                    id: subfiderId,
                    fiderId: fider.id,
                    taskId: task.id,
                    task,
                    tooltipPosition: { lat: centerLat, lng: centerLng },
                    offset: [18, -35],
                    priority: segmentLength // приоритет по длине сегмента
                });
            });
        });

        // Для каждой задачи проверяем пересечения тултипов только внутри этой задачи
        taskGroups.forEach((subfiders, taskId) => {
            if (subfiders.length <= 1) {
                // Если только один субфидер в задаче, добавляем его
                subfiders.forEach(subfider => visibleSubfiderIds.add(subfider.id));
                return;
            }

            // Сортируем субфидеры задачи по приоритету (более длинные сегменты имеют приоритет)
            subfiders.sort((a, b) => b.priority - a.priority);

            const acceptedTooltips = [];

            // Проверяем пересечения только внутри текущей задачи
            for (const currentSubfider of subfiders) {
                let hasIntersection = false;

                // Проверяем пересечение только с уже принятыми тултипами этой же задачи
                for (const acceptedSubfider of acceptedTooltips) {
                    if (checkTooltipIntersection(
                        currentSubfider.tooltipPosition,
                        acceptedSubfider.tooltipPosition,
                        map
                    )) {
                        hasIntersection = true;
                        break;
                    }
                }

                if (!hasIntersection) {
                    acceptedTooltips.push(currentSubfider);
                    visibleSubfiderIds.add(currentSubfider.id);
                }
            }
        });

        return visibleSubfiderIds;
    }, [fiders, taskFidersMap, map, mapState.bounds, mapState.zoom]);

    // Расчет расстояний
    // const calculateDistance = useCallback((coordinates) => {
    //     let distance = 0;
    //     for (let i = 1; i < coordinates.length; i++) {
    //         const prevCoord = coordinates[i - 1];
    //         const currCoord = coordinates[i];
    //         const from = new L.LatLng(prevCoord[0], prevCoord[1]);
    //         const to = new L.LatLng(currCoord[0], currCoord[1]);
    //         distance += from.distanceTo(to);
    //     }
    //     return distance;
    // }, []);

    // Расчет общего расстояния для всех фидеров
    // useEffect(() => {
    //     if (!fiders?.length) return;

    //     let totalDistance = 0;
    //     for (const fider of fiders) {
    //         if (fider.coordinates?.length > 1) {
    //             totalDistance += calculateDistance(fider.coordinates);
    //         }
    //     }

    //     dispatch(setDistances({
    //         layer: props.class,
    //         distance: totalDistance.toFixed(0)
    //     }));
    // }, [fiders, props.class, dispatch, calculateDistance]);

    // Условие рендеринга
    if (!fiders) {
        return null;
    }
    // const shouldShowDistances = (printing && printing.measure) ||
    //     (dialFilter && dialFilter.otherLabels && zoom > 17)

    // console.log('LayerFiders debug:', {
    //     zoom,
    //     shouldShowDistances,
    //     printing: !!printing,
    //     printingMeasure: printing?.measure,
    //     dialFilter: !!dialFilter,
    //     dialFilterOtherLabels: dialFilter?.otherLabels,
    //     fidersCount: fiders.length
    // });
    // if (!showFiders) return null;
    const markers = fiders.map((mark, idx) => {

        // Создаем bounds только один раз
        const markBounds = new L.LatLngBounds(
            new L.LatLng(mark.bounds[0][0], mark.bounds[0][1]),
            new L.LatLng(mark.bounds[1][0], mark.bounds[1][1])
        );

        if (!bounds.intersects(markBounds)) return null;

        // let coordinates = mark.coordinates;
        // if (coordinates?.length === 1) coordinates = [];

        // Расчет расстояний для отображения
        // let distances = [];
        // if (shouldShowDistances && coordinates?.length > 1) {
        //     for (let i = 0; i < coordinates.length - 1; i++) {
        //         const from = new L.LatLng(coordinates[i][0], coordinates[i][1]);
        //         const to = new L.LatLng(coordinates[i + 1][0], coordinates[i + 1][1]);
        //         distances.push(from.distanceTo(to).toFixed(0) + 'м');
        //     }
        // }

        // console.log(`Fider ${mark.id}:`, {
        //     coordinatesLength: coordinates?.length,
        //     shouldShowDistances,
        //     distancesLength: distances.length,
        //     distances: distances.slice(0, 3) // первые 3 для отладки
        // });

        let text = '';
        // let status = '';
        // let colorSchema = {}
        const task = taskFidersMap.get(mark.id)
        const subfiders = []
        if (task) {
            task.map(t => {
                const colorSchema = usersSettings.find(us => us.id === t.responsible)?.settings
                subfiders.push({
                    id: t.id,
                    text: t.text,
                    coordinates: mark.coordinates.slice(Math.min(...t.segments), Math.max(...t.segments) + 1).map(coord => [coord[0] + 0.000008, coord[1] + 0.000012]),
                    mainColor: colorSchema?.line_color || '#0000ff',
                    zebraColor: colorsForStatuses.has(t?.status) ? colorsForStatuses.get(t.status) : (colorSchema?.line_color || '#0000ff'),
                    responsible: t.responsible,
                    status: t.status
                })
            })


            // text = task.text
            // colorSchema = usersSettings.find(us => us.id === task.responsible_id)?.settings
            // status = task.status
        } else {
            return null
        }

        // Функция для проверки, должен ли субфидер показывать тултип
        const shouldShowSubfiderTooltip = (taskId) => {
            if (drawing) return false;
            const subfiderId = `${mark.id}_${taskId}`;
            return visibleSubfiders.has(subfiderId);
        };


        // let coordinates = mark.coordinates.slice(Math.min(...task.segments), Math.max(...task.segments) + 1).map(coord => [coord[0] + 0.000007, coord[1] + 0.000011])

        // const mainColor = colorSchema?.line_color || '#0000ff';
        // const zebraColor = colorsForStatuses.has(task?.status) ? colorsForStatuses.get(task.status) : (colorSchema?.line_color || '#0000ff');
        const lineWeight = 6;
        const dashPattern = '30, 35';
        return (subfiders.map((sf, i) => (
            [<Polyline // The background color of the stripes
                key={`${mark.id}_${sf.id}_${i}_${keyForRender}_background`}
                positions={sf.coordinates}
                color={sf.zebraColor}
                weight={lineWeight}
                opacity={1}
                interactive={!drawing}
            />,
            <Polyline // The foreground color of the stripes
                key={`${mark.id}_${sf.id}_${i}_${keyForRender}_foreground`}
                positions={sf.coordinates}
                color={sf.mainColor}
                data={mark.id}
                type="fiderPhantom"
                weight={lineWeight}
                dashArray={dashPattern}
                smoothFactor={0}
                interactive={!drawing}
            >
                {shouldShowSubfiderTooltip(sf.id) && (
                    <Tooltip
                        key={`${mark.id}_${sf.id}_${i}_tooltip`}
                        permanent
                        sticky
                        direction="right"
                        offset={[18, -35]}
                        className={`dynamic-phantom-tooltip tooltip-user-${sf.responsible}`}

                    >
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 0.5,
                            opacity: 1
                        }}>
                            {getTaksIcon(sf.status)}

                            {sf.text}
                        </Box>
                    </Tooltip>
                )}
            </Polyline>]
            //  </React.Fragment>
        )));
    }).filter(Boolean);

    // Добавляем маркеры границ задач
    const borderMarkers = tasksBorders.map((border, i) => (
        <Marker
            position={[border[0] + 0.000007, border[1] + 0.000011]}
            key={`border_${i}_${keyForRender}`}
            icon={createBorderIcon()}
            pane="otherPane"
        >
            <Tooltip
                key={`border_${i}_${keyForRender}_tooltip`}
                direction="right"
            >
                Граница планов
            </Tooltip>
        </Marker>
    ));

    return [...markers, ...borderMarkers];
};

LayerPlan.displayName = 'LayerPlan';


function getTaksIcon(taskStatus) {
    const forStatuses = ['progress', 'done', 'paused', 'cancelled']
    if (!forStatuses.includes(taskStatus)) return null
    switch (taskStatus) {
        case 'progress':
            return <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px">
                <circle cx="480" cy="-480" r="480" fill="#eee" />
                <path d="m400-320 240-160-240-160v320Zm80 240q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-43 9-84.5t26-80.5l62 62q-8 26-12.5 51.5T160-480q0 134 93 227t227 93q134 0 227-93t93-227q0-134-93-227t-227-93q-27 0-52.5 4.5T377-783l-61-61q40-18 80-27t84-9q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80ZM220-680q-25 0-42.5-17.5T160-740q0-25 17.5-42.5T220-800q25 0 42.5 17.5T280-740q0 25-17.5 42.5T220-680Zm260 200Z"
                    fill="#3874cb"

                    stroke="#3874cb"
                    strokeWidth={10}
                />
            </svg>
        case 'done':
            return <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" >
                <circle cx="480" cy="-480" r="480" fill="#eee" />
                <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q65 0 123 19t107 53l-58 59q-38-24-81-37.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-18-2-36t-6-35l65-65q11 32 17 66t6 70q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-56-216L254-466l56-56 114 114 400-401 56 56-456 457Z"
                    fill="#457b3b"

                    stroke="#457b3b"
                    strokeWidth={10}
                />
            </svg>
        case 'paused':
            return <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px">
                <circle cx="480" cy="-480" r="480" fill="#eee" />
                <path d="M360-360h80v-240h-80v240Zm160 0h80v-240h-80v240ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-43 9-84.5t26-80.5l62 62q-8 26-12.5 51.5T160-480q0 134 93 227t227 93q134 0 227-93t93-227q0-134-93-227t-227-93q-27 0-52.5 4.5T377-783l-61-61q40-18 80-27t84-9q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80ZM220-680q-25 0-42.5-17.5T160-740q0-25 17.5-42.5T220-800q25 0 42.5 17.5T280-740q0 25-17.5 42.5T220-680Zm260 200Z"
                    fill="#d55c26"
                    stroke="#d55c26"
                    strokeWidth={10}
                />
            </svg>
        case 'cancelled':
            return <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px">
                <circle cx="480" cy="-480" r="480" fill="#eee" />
                <path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                    fill="#424242"

                    stroke="#424242"
                    strokeWidth={10}
                />
            </svg>
        default:
            return null
    }
}